import React from "react";
import RouterConfig from "./router";
import "./App.css";
// import useFirestore from "./hooks/useFirestore";

function App() {
  //   useFirestore("images");
  return <RouterConfig />;
}

export default React.memo(App);
